const firebaseConfig = {
    apiKey: "AIzaSyDhHNrwYOwSFzx_GTLEScyzty8EVrEzxeM",
    authDomain: "creative-agency-de1e4.firebaseapp.com",
    databaseURL: "https://creative-agency-de1e4.firebaseio.com",
    projectId: "creative-agency-de1e4",
    storageBucket: "creative-agency-de1e4.appspot.com",
    messagingSenderId: "989751617568",
    appId: "1:989751617568:web:2b8ff404530147b33d7445"
  };
  
  export default firebaseConfig;